import "@fontsource/inter";
import "@fontsource/inter/700.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/400.css";
import styled from "styled-components";
import { theme } from "../../../theme";

//NOTE: XS is a very small font size and should be used sparingly for less important information.

const XS = styled.div<{
  textalign?: string;
  color?: string;
  fontweight?: string | number;
}>`
  font-family: "Inter", sans-serif;
  font-size: 10px;
  color: ${(props) => props.color ?? theme.colors.text};
  text-align: ${(props) => props.textalign ?? "left"};
  line-height: 12px;
  font-weight: ${(props) => props.fontweight ?? "400"};
`;

export default XS;
